<template>
    <h4 style="text-transform: capitalize;
    text-align: center;
    margin-top: 25px;">{{static_title}}</h4>
    <div style="margin: 0 18px; color:#8d8d8d; text-align:justify;" v-html="static_content"></div>

</template>

<script>

import "@meforma/vue-toaster";

export default {
  name: 'StaticPage',
  data: function (){
    return {
      static_title:null,
      static_content:null,
    }
  },
  methods : {

  },
  mounted: function(){
      var config = {
      method: 'get',
      url: process.env.VUE_APP_BASE_URI+'/api/static/detail/'+this.$route.params.page_id,
      headers: {
      }
    };
    this.axios(config)
    .then(response => {
      if(response.status){
        var data = response.data.data;
        this.static_title = data.page_name;
        this.static_content = data.page_content
      }
    });
  }
}
</script>

<style>
a:hover {
  text-decoration: none !important;
}
.frame {
    overflow-y: auto;
	height:108px;	
	}
	.frame::-webkit-scrollbar {
  width: 3px;
}
.frame::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.frame::-webkit-scrollbar-thumb {
  background: #888; 
}
.frame::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
#btnsubmit{
  color: #ff6426;
    font-weight: 500;
}
</style>

